import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import {PartMenuType} from "../../constants";
import BodyPanel from "./bodyPanel";
import BodyItems from "./bodyItems";
import Analytics from "../../../../analytics";
import FilterSelection from "../newFilters/filterSelection";
import NavigationFilters from "../newFilters/navigationFilters";
import {CABINET_WIZARD_BUTTONS} from "../../../kvComponent/core/constants";
import NavigationFiltersSteps from "../newFilters/navigationFiltersSteps";
import {getCurrentLayout} from "../../../appLayout";
import Config from "../../../../config";
import {getPartThemeThumbnail} from "../../../../misc/helpers";

class BodyClass extends Component {

  static propTypes = {
    parentItem: PropTypes.instanceOf(DesignNavigationItem),
    childItem: PropTypes.instanceOf(DesignNavigationItem),
    navWidth: PropTypes.number,
    searchText: PropTypes.string,
    onItemClick: PropTypes.func.isRequired,
    toggleApplyWallsCheckbox: PropTypes.func,
    isWallItem: PropTypes.func,
    handleSubTypeClick: PropTypes.func,
    showMenu: PropTypes.bool,
    toggleUserPopup: PropTypes.func,
    activeFeature: PropTypes.object,
    wizardGroups: PropTypes.array,
    useWizard: PropTypes.bool,
    showFeatureWizard: PropTypes.bool,
    enableFeatureWizard: PropTypes.func,
    exitFeatureWizard: PropTypes.func,
    getFilterDisplayName: PropTypes.func.isRequired,
    useFilters: PropTypes.bool,
    removeFilterSelection: PropTypes.func,
    showFilterSelection: PropTypes.bool,
    toggleWizardFilterSelection: PropTypes.func,
    refreshCB: PropTypes.func,
    setStateActiveFeature: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      showLoader: false
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedFilters.length) {
      let updateComponent = false;
      if (nextProps.selectedFilters.length === this.props.selectedFilters.length) {
        updateComponent = nextProps.selectedFilters.some((filter, index) => {
          return filter.filterId !== this.props.selectedFilters[index].filterId
            || filter.filterGroupId !== this.props.selectedFilters[index].filterGroupId
        });
      }
      if (updateComponent) {
        this.refreshItems();
      }
    }
    if (this.props.navigationLoadingActive && !nextProps.navigationLoadingActive) {
      this.refreshItems();
    }
  }

  refreshItems = () => {
    this.setState({
      showLoader: true
    }, () => {
      this.setState({
        showLoader: false
      })
    })
  };

  itemsDispatcher = () => {
    const parentItem = this.props.parentItem;
    if (!parentItem) {
      return (
        <ul className={"categories-list categories-list--"+ this.props.navigationViewType
        + (parentItem ? " categories-list--grid" : "") + (this.props.filtersVisible ? ' categories-list--filters-visible' : '')}>
          {this.level1Items()}
        </ul>
      )
    }
    // if (parentItem && !childItem) {
    //   if (parentItem.part.isSubTypeWithItems()) {
    //     return this.level2ItemsNew(parentItem.part.navigationSubItems(selectedFilters, this.props.searchText)); // complete Vanity, complete Bathtub
    //   }
    //   return [];
    // }
    return this.level2ItemsNew();
  };

  level1Items = () => {
    const layout = getCurrentLayout();
    const {searchText, parentItem, selectedFilters, activeTheme} = this.props;
    const items = layout.designNavigationItems(parentItem, selectedFilters, searchText)
      .filter(item => {
        if (Config.showAllVisualizerGroups()) {
          return true
        }
        if (item.part.menuType === PartMenuType.Simple) {
          return layout.designNavigationItems(item).length
        } else {
          const subParts = item.part.subParts();
          return subParts.length && subParts.some(subPart => layout.hasNavItemsLength(subPart))
        }
      });
    return items.map(item => {
      const style = {
        backgroundImage: `url(${getPartThemeThumbnail(item.part.partThumbnail, activeTheme)})`,
      };
      if (item.part.partThumbnailSize) {
        style.backgroundSize = item.part.partThumbnailSize
      }
      return (
        <li className="categories-list__item" key={item.text} onClick={() => {
          Analytics.sendClickEvent('item-clicked');
          Analytics.sendClickEvent('item-clicked-' + item.part.partName);
          this.props.onItemClick(item)
        }}>
          <div className={"category"} style={style}>
            <span className="category-text"><FormattedMessage id={item.part.translateId}/></span>
          </div>
        </li>
      )
    })
  };

  updateComponent = () => {
    this.forceUpdate();
  };

  getFeatures = (layout) => {
    const {parentItem, childItem, searchText, selectedFilters} = this.props;
    const currentParent = (parentItem.part.menuType === PartMenuType.Simple) ? parentItem : childItem;
    if (!currentParent) {
      return []
    }
    return layout.designNavigationItems(currentParent, selectedFilters, searchText);
  };

  level2ItemsNew = () => {
    const layout = getCurrentLayout();
    const activePart = this.props.parentItem ? this.props.parentItem.part : null;
    const activeSubPart = this.props.childItem ? this.props.childItem.part : null;
    const currentPart = activeSubPart || activePart;
    const allFeaturesReceived = currentPart && currentPart.allFeaturesReceived
      && (!(currentPart.nextFeaturesPageToLoadArray && !currentPart.nextFeaturesPageToLoadArray[layout.getCurrentLayoutAbbreviation()].page));

      return <BodyItems features={this.getFeatures(layout)}
                      parentItem={this.props.parentItem}
                      onItemClick={this.props.onItemClick}
                      childItem={this.props.childItem}
                      showMenu={this.props.showMenu}
                      toggleUserPopup={this.props.toggleUserPopup}
                      activeFeature={this.props.activeFeature}
                      searchText={this.props.searchText}
                      layoutName={layout.getCurrentLayoutName()}
                      existInQtCategory={layout.qtCategories ? activeSubPart && activeSubPart.existInQtCategory : true}
                      allFeaturesReceived={allFeaturesReceived}
                      parentUpdate={this.updateComponent}
    />;
  };

  render() {

    const activePart    = this.props.parentItem ? this.props.parentItem.part : null;
    const activeSubPart = this.props.childItem ? this.props.childItem.part : null;
    const activeNavPart = activeSubPart || activePart;

    const filterSelectionHasValues = (activeSubPart || activePart) && FilterSelection.getAvailableFilterValues(
      this.props.filterGroups, "Material", activeSubPart || activePart, this.props.fabricatorData
    ).length > 0;


    // const fabricatorSettings = this.props.fabricatorData.settings;
    // const useWizard = fabricatorSettings &&
    //   (fabricatorSettings.wizardConsumers || (fabricatorSettings.wizardClients && document.kvConfig.isBackend));

    const useKVWizard = false; //TODO change it when BE is ready

    const showNavigationFilters = useKVWizard && this.props.activeNavigationFilter && activeNavPart
      && this.props.activeNavigationFilter !== CABINET_WIZARD_BUTTONS[0].buttonId
      && activeNavPart.canUseNavigationFilter && activeNavPart.canUseNavigationFilter();
    let showNavigationFiltersSteps = showNavigationFilters && this.props.activeNavigationFilter !== "inlay_type";

    if (useKVWizard && activeNavPart && activeNavPart.canUseNavigationFilterSteps
      && activeNavPart.canUseNavigationFilterSteps()) {
      showNavigationFiltersSteps = !this.props.countertopNavigationFilterCompleted;
    }

    return (
      <div className="design-cell design-cell--center">
        {activePart
          ? <BodyPanel activePart={activePart}
                       activeSubPart={activeSubPart}
                       activeFeature={this.props.activeFeature}
                       toggleApplyWallsCheckbox={this.props.toggleApplyWallsCheckbox}
                       isWallItem={this.props.isWallItem}
                       handleSubTypeClick={this.props.handleSubTypeClick}
                       useWizard={this.props.useWizard}
                       showFeatureWizard={this.props.showFeatureWizard}
                       wizardGroups={this.props.wizardGroups}
                       enableFeatureWizard={this.props.enableFeatureWizard}
                       exitFeatureWizard={this.props.exitFeatureWizard}
                       getFilterDisplayName={this.props.getFilterDisplayName}
                       showFilterSelection={this.props.useFilters &&
                       this.props.showFilterSelection && filterSelectionHasValues}
                       useFilters={this.props.useFilters}
                       toggleWizardFilterSelection={this.props.toggleWizardFilterSelection}
                       refreshCB={this.props.refreshCB}
                       refreshItems={this.refreshItems}
                       setStateActiveFeature={this.props.setStateActiveFeature}
          />
          : null}
        {this.props.useFilters && this.props.showFilterSelection && filterSelectionHasValues ? (
          <FilterSelection removeFilterSelection={this.props.removeFilterSelection}
                           filterGroupName="Material"
                           activePart={activeNavPart}
                           isMobile={false}
          />
        ) : showNavigationFilters
          ? (
            <NavigationFilters
              activePart={activeSubPart || activePart}
              isMobile={false}
              onItemClick={this.props.onItemClick}
              refreshCB={this.props.refreshCB}
            />
          ) : (
            this.state.showLoader
              ? <div className="message-loading-left-panel-spinner message-loading-left-panel-spinner--small"/>
              : this.itemsDispatcher()
            // !this.state.showLoader
            //   ? allFeaturesReceived
            //     ? this.itemsDispatcher()
            //     : (activeSubPart || activePart)
            //       ? this.showLoadingItems(activeSubPart || activePart)
            //       : this.itemsDispatcher()
            //   : <div className="message-loading-left-panel-spinner message-loading-left-panel-spinner--small"/>
          )}
        {showNavigationFiltersSteps ? (
          <NavigationFiltersSteps activePart={activeNavPart} />
        ) : null}
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    fabricatorData: store.fabricatorState,
    filterGroups: store.filterState.filterGroups,
    filtersVisible: store.filterState.showFilters,
    selectedFilters: store.filterState.selectedFilters,
    navigationViewType: store.navigationState.navigationViewType,
    activeNavigationFilter: store.navigationState.activeNavigationFilter,
    countertopNavigationFilterCompleted: store.navigationState.countertopNavigationFilterCompleted,
    navigationLoadingActive: store.navigationState.navigationLoadingActive,
    activeTheme: store.serverState.activeTheme,
  };
};
const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(BodyClass);
